<div *ngIf="spinner" class="loading-overlay">
  <div class="spinner-border text-light" role="status"></div>
</div>

<section class="relatives-vo">
  <div class="content">
    <section class="content--item">
      <h5 class="content--title">
        {{ 'myRelatives' | i18next }}
      </h5>

      <div class="table-wrapper" *ngIf="!spinner">
        <table
          class="custom-table"
          *ngIf="relativesList.length > 0; else emptyTpl"
        >
          <thead>
            <tr>
              <th>{{ 'name' | i18next }}</th>
              <th>{{ 'creationDate' | i18next }}</th>
              <th>{{ 'status' | i18next }}</th>
              <th class="text-center">
                {{ 'requestListActions' | i18next }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="let relative of relativesList; trackBy: trackByRelative"
            >
              <td>{{ relative.name }}</td>
              <td>{{ relative.date | date: 'dd/MM/yyyy' }}</td>
              <td>{{ getStatusLabel(relative.status) | i18next }}</td>
              <td class="text-center actions-cell">
                <button
                  type="button"
                  class="btn relatives-action-btn"
                  (click)="toggleRelativeStatus(relative)"
                >
                  {{
                    relative.status
                      ? ('deactivate' | i18next | uppercase)
                      : ('activate' | i18next | uppercase)
                  }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #emptyTpl>
        <div class="empty-state">
          {{ 'noData' | i18next }}
        </div>
      </ng-template>

      <form class="content__form" [formGroup]="form">
        <h5 class="content--title">
          {{ 'createFamiliar' | i18next }}
        </h5>

        <div class="form-two-columns">
          <mat-form-field appearance="fill">
            <mat-label>{{ 'name' | i18next }}</mat-label>
            <input type="text" matInput formControlName="name" />
            <mat-error *ngIf="f['name'].hasError('required')">
              {{ 'requieredField' | i18next }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>{{ 'firstSurname' | i18next }}</mat-label>
            <input type="text" matInput formControlName="firstSurName" />
            <mat-error *ngIf="f['firstSurName'].hasError('required')">
              {{ 'requieredField' | i18next }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>{{ 'secondSurname' | i18next }}</mat-label>
            <input type="text" matInput formControlName="secondSurName" />
            <mat-error *ngIf="f['secondSurName'].hasError('required')">
              {{ 'requieredField' | i18next }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>{{ 'nif' | i18next }}</mat-label>
            <input type="text" matInput formControlName="nif" maxlength="9" />
            <mat-error *ngIf="f['nif'].hasError('required')">
              {{ 'requieredField' | i18next }}
            </mat-error>
            <mat-error *ngIf="f['nif'].hasError('pattern')">
              {{ 'invalidNif' | i18next }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>{{ 'email' | i18next }}</mat-label>
            <input type="email" matInput formControlName="email" />
            <mat-error *ngIf="f['email'].hasError('required')">
              {{ 'requieredField' | i18next }}
            </mat-error>
            <mat-error *ngIf="f['email'].hasError('email')">
              {{ 'emailInvalid' | i18next }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>{{ 'relationship' | i18next }}</mat-label>
            <mat-select formControlName="relationship">
              <mat-option
                *ngFor="let option of relationshipOptions"
                [value]="option"
              >
                {{ option | i18next }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="f['relationship'].hasError('required')">
              {{ 'requieredField' | i18next }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>{{ 'phoneNumber' | i18next }}</mat-label>
            <input
              type="text"
              matInput
              formControlName="phoneNumber"
              maxlength="9"
            />
            <mat-error *ngIf="f['phoneNumber'].hasError('pattern')">
              {{ 'phoneNumberIncorrect' | i18next }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-checkbox-row">
          <mat-checkbox
            formControlName="accessAuthorization"
            (change)="onAccessAuthorizationChange($event)"
          >
            {{ 'authorizeAccess' | i18next }}*
          </mat-checkbox>

          <mat-error
            *ngIf="
              f['accessAuthorization'].hasError('required') &&
              f['accessAuthorization'].touched
            "
          >
            {{ 'requieredField' | i18next }}
          </mat-error>
        </div>

        <div class="form-actions">
          <button
            type="button"
            class="btn relatives-save-btn"
            (click)="submit()"
            [disabled]="form.invalid"
          >
            {{ 'btnSave' | i18next | uppercase }}
          </button>
        </div>
      </form>
    </section>
  </div>
</section>
